import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/http-api';
import { Schema } from 'effect';
import {
  DottedVersion,
  MobileReleaseChannel,
  MobileReleasePlatform,
} from './schemas/mobile-release';

export const MinimumVersionResponse = Schema.Struct({
  /** The lowest native version allowed to run, or null when this platform has
   * no floor. Null never blocks — it is also the kill switch. */
  minimumVersion: Schema.NullOr(DottedVersion),
}).annotate({
  identifier: 'MobileMinimumVersionResponse',
  title: 'Mobile minimum supported version',
});

const minimumVersionEndpoint = HttpApiEndpoint.get(
  'GetMinimumVersion',
  '/minimum-version',
  {
    query: Schema.Struct({
      channel: MobileReleaseChannel,
      platform: MobileReleasePlatform,
    }),
    success: MinimumVersionResponse.pipe(HttpApiSchema.status(200)),
  },
)
  .annotate(OpenApi.Summary, 'Mobile minimum supported version')
  .annotate(
    OpenApi.Description,
    [
      'The lowest NATIVE app version allowed to run, for one (channel, platform) pair.',
      'The mobile client replaces itself with an "Update required" screen when its',
      'installed binary version is below this. `null` never blocks.',
      '',
      'This replaces reading the `[:mav:]` (App Store) / `[Minimum supported app',
      'version:]` (Play) tags out of the store listings. The App Store description is',
      'only editable as part of a new version submission, so that tag could never be',
      'changed during an incident, and the Play tag was being sliced out of',
      'undocumented HTML that fails open whenever Google reshuffles the page.',
      '',
      'The floors are a hardcoded table in the api',
      '(`@listening/backend/mobile-release/minimum-version`); changing one is a deploy.',
      'Nothing here governs OTA updates — an OTA does not move the version compared',
      'here, and a bad OTA payload is rolled back with `publish-ota repoint` instead.',
      '',
      'Public and unauthenticated (a blocked install may have no session) and global',
      'rather than per-user, so unlike Analytics.Bootstrap it is CDN-cacheable.',
      'It cannot fail: the answer is a constant lookup.',
    ].join('\n'),
  );

export const mobileReleaseGroup = HttpApiGroup.make('MobileRelease')
  .add(minimumVersionEndpoint)
  .prefix('/mobile-release');
